import AccountCompany from "./AccountCompany";
import ButtonRightIcon from "../../../Common/Components/ButtonRightIcon";
import PlusIcon from "../../../../assets/img/icons/addWhite.svg";

function AccountCompanyAdd(props: any) {
  const { account, handleAddAccount, state, loading, handleAccountSelection, index } = props;
  function addAccount() {
    handleAddAccount(account);
  }
  return (
    <div className="d-flex flex-column align-items-center">
      <AccountCompany
        key={index}
        handleAccountSelection={handleAccountSelection}
        checked={false}
        account={{
          accountId: account.companyid,
          accountLogo: account.logo,
          accountPulse: account.accountPulse,
          accountPersonality: account.accountPersonality,
          accountSubscribers: account.accountSubscribers,
          accountShare: account.accountShare,
          accountTicker: account.accountTicker,
          accountName: account.name,
          state,
        }}
        hideSelected={account.flag === "False" ? true : false}
      />
      {account.flag === "False" ? (
        <ButtonRightIcon
          label="Add as company"
          icon={PlusIcon}
          onClick={addAccount}
          green="green"
          disabled={loading}
        />
      ) : null}
    </div>
  );
}

export default AccountCompanyAdd;
